import { render, staticRenderFns } from "./TodoActiveContentDetailsSidedbar.vue?vue&type=template&id=63db21fa&scoped=true&"
import script from "./TodoActiveContentDetailsSidedbar.vue?vue&type=script&lang=js&"
export * from "./TodoActiveContentDetailsSidedbar.vue?vue&type=script&lang=js&"
import style0 from "./TodoActiveContentDetailsSidedbar.vue?vue&type=style&index=0&id=63db21fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63db21fa",
  null
  
)

export default component.exports